export default __webpack_public_path__ + "static/media/arrow-icon.761e157d.svg";